import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const servicios = [
  {
    icon: '👤',
    titulo: 'Préstamos Personales',
    descripcion: 'Soluciones financieras rápidas para tus necesidades personales con tasas competitivas.',
    link: '/servicios'
  },
  {
    icon: '💵',
    titulo: 'Préstamos Generales',
    descripcion: 'Financiamiento flexible para cualquier proyecto o necesidad, con condiciones adaptadas a ti.',
    link: '/servicios'
  },
  {
    icon: '🏢',
    titulo: 'Préstamos PYME',
    descripcion: 'Impulsa tu negocio con financiamiento diseñado para pequeñas y medianas empresas.',
    link: '/servicios'
  },
  {
    icon: '🏠',
    titulo: 'Préstamos Hipotecarios',
    descripcion: 'Haz realidad el sueño de tu hogar con nuestras soluciones hipotecarias flexibles.',
    link: '/servicios'
  },
  {
    icon: '💳',
    titulo: 'Línea de Crédito Superior',
    descripcion: 'Acceso inmediato a dinero disponible cuando lo necesites, pagando solo por lo que usas.',
    link: '/servicios'
  },
  {
    icon: '🚗',
    titulo: 'Financiamiento General',
    descripcion: 'Conduce tu vehículo ideal con planes de financiamiento accesibles y convenientes.',
    link: '/servicios'
  },
  {
    icon: '🏍️',
    titulo: 'Inversiones JM',
    descripcion: 'Motocicletas y pasolas con planes de financiamiento a tu medida.',
    link: '/jm-inversiones'
  },
];

const razones = [
  { icon: '⚡', titulo: 'Aprobación Rápida', desc: 'Proceso ágil y sin complicaciones para que obtengas tu dinero cuando lo necesitas.' },
  { icon: '🤝', titulo: 'Trato Personalizado', desc: 'Te atendemos de manera cercana y honesta, adaptándonos a tu situación.' },
  { icon: '🔒', titulo: 'Confianza y Seguridad', desc: 'Operamos con total transparencia y bajo los más altos estándares de integridad.' },
  { icon: '📊', titulo: 'Tasas Competitivas', desc: 'Ofrecemos condiciones financieras justas y competitivas en el mercado.' },
];

const Home = () => {
  const [calc, setCalc] = useState({ monto: 50000, plazo: 12, tasa: 3.5 });

  // Cargar script de Elfsight una sola vez
  useEffect(() => {
    if (document.querySelector('script[src="https://elfsightcdn.com/platform.js"]')) return;
    const script = document.createElement('script');
    script.src = 'https://elfsightcdn.com/platform.js';
    script.async = true;
    document.body.appendChild(script);
  }, []);

  const calcularCuota = () => {
    const r = calc.tasa / 100;
    const n = calc.plazo;
    const P = calc.monto;
    const cuota = (P * r * Math.pow(1 + r, n)) / (Math.pow(1 + r, n) - 1);
    return isNaN(cuota) ? 0 : cuota.toFixed(2);
  };

  const totalPagar = (parseFloat(calcularCuota()) * calc.plazo).toFixed(2);

  return (
    <div className="home">

      {/* ── HERO ── */}
      <section className="hero">
        <div className="hero-bg">
          <div className="hero-shape-1"></div>
          <div className="hero-shape-2"></div>
        </div>
        <div className="container">
          <div className="hero-content">
            <div className="hero-left">
              <span className="hero-badge">Financiera JM ODEPEM S.R.L.</span>
              <h1 className="hero-title">
                Solicita tu<br />
                <span>Línea de Crédito</span><br />
                Superior
              </h1>
              <p className="hero-subtitle">
               <strong>Nos ajustamos a tu necesidad.</strong> Obtén el financiamiento que necesitas con tasas competitivas y aprobación rápida en República Dominicana.
              </p>
              <div className="hero-actions">
                <Link to="/Solicitud" className="btn-primary">
                  Realiza tu solicitud →
                </Link>
                <Link to="/servicios" className="btn-outline">
                  Ver servicios
                </Link>
              </div>
              <div className="hero-stats">
                <div className="stat">
                  <span className="stat-num">+5,000</span>
                  <span className="stat-label">Clientes satisfechos</span>
                </div>
                <div className="stat-divider"></div>
                <div className="stat">
                  <span className="stat-num">+4</span>
                  <span className="stat-label">Años de experiencia</span>
                </div>
                <div className="stat-divider"></div>
                <div className="stat">
                  <span className="stat-num">6</span>
                  <span className="stat-label">Servicios financieros</span>
                </div>
              </div>
            </div>
            <div className="hero-right">
              <div className="hero-card">
                <div className="hero-card-header">
                  <span>💰</span>
                  <span>Solicitud Rápida</span>
                </div>
                <div className="hero-card-body">
                  <div className="hero-card-item">
                    <span>Aprobación</span>
                    <strong className="green-text">Rápida</strong>
                  </div>
                  <div className="hero-card-item">
                    <span>Tasas</span>
                    <strong className="green-text">Competitivas</strong>
                  </div>
                  <div className="hero-card-item">
                    <span>Plazos</span>
                    <strong className="green-text">Flexibles</strong>
                  </div>
                  <div className="hero-card-item">
                    <span>Atención</span>
                    <strong className="green-text">Personalizada</strong>
                  </div>
                </div>
                <Link to="/Solicitud" className="hero-card-btn">
                  Solicitar ahora →
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── SERVICIOS ── */}
      <section className="section servicios-section">
        <div className="container">
          <div className="section-header">
            <span className="section-label">Lo que ofrecemos</span>
            <h2 className="section-title">Nuestros <span>Servicios</span></h2>
            <p className="section-subtitle">
              Soluciones financieras diseñadas para impulsar tus metas personales y empresariales.
            </p>
          </div>
          <div className="servicios-grid">
            {servicios.map((s, i) => (
              <Link to={s.link} key={i} className="servicio-card">
                <div className="servicio-icon">{s.icon}</div>
                <h3>{s.titulo}</h3>
                <p>{s.descripcion}</p>
                <span className="servicio-link">Conocer más →</span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* ── CALCULADORA ── */}
      <section className="section calc-section">
        <div className="container">
          <div className="calc-wrapper">
            <div className="calc-left">
              <span className="section-label">Herramienta financiera</span>
              <h2 className="section-title">Calculadora de <span>Préstamos</span></h2>
              <p className="section-subtitle">
                Estima tu cuota mensual de forma rápida y sencilla. Ajusta el monto, plazo y tasa según tus necesidades.
              </p>
              <div className="calc-note">
                * Los valores son estimados. Contáctanos para una cotización exacta.
              </div>
            </div>
            <div className="calc-right">
              <div className="calculator">
                <div className="calc-field">
                  <label>Monto del préstamo</label>
                  <div className="calc-input-row">
                    <span className="calc-prefix">RD$</span>
                    <input
                      type="number"
                      value={calc.monto}
                      onChange={e => setCalc({ ...calc, monto: parseFloat(e.target.value) || 0 })}
                    />
                  </div>
                  <input
                    type="range" min="5000" max="500000" step="5000"
                    value={calc.monto}
                    onChange={e => setCalc({ ...calc, monto: parseFloat(e.target.value) })}
                    className="calc-range"
                  />
                  <div className="calc-range-labels">
                    <span>RD$ 5,000</span>
                    <span>RD$ 500,000</span>
                  </div>
                </div>

                <div className="calc-field">
                  <label>Plazo (meses)</label>
                  <div className="calc-input-row">
                    <input
                      type="number"
                      value={calc.plazo}
                      onChange={e => setCalc({ ...calc, plazo: parseInt(e.target.value) || 1 })}
                    />
                    <span className="calc-suffix">meses</span>
                  </div>
                  <input
                    type="range" min="3" max="60" step="3"
                    value={calc.plazo}
                    onChange={e => setCalc({ ...calc, plazo: parseInt(e.target.value) })}
                    className="calc-range"
                  />
                  <div className="calc-range-labels">
                    <span>3 meses</span>
                    <span>60 meses</span>
                  </div>
                </div>

                <div className="calc-field">
                  <label>Tasa de interés mensual (%)</label>
                  <div className="calc-input-row">
                    <input
                      type="number" step="0.1"
                      value={calc.tasa}
                      onChange={e => setCalc({ ...calc, tasa: parseFloat(e.target.value) || 0 })}
                    />
                    <span className="calc-suffix">%</span>
                  </div>
                </div>

                <div className="calc-result">
                  <div className="calc-result-item">
                    <span>Cuota mensual estimada</span>
                    <strong>RD$ {parseFloat(calcularCuota()).toLocaleString('es-DO', { minimumFractionDigits: 2 })}</strong>
                  </div>
                  <div className="calc-result-item">
                    <span>Total a pagar</span>
                    <strong>RD$ {parseFloat(totalPagar).toLocaleString('es-DO', { minimumFractionDigits: 2 })}</strong>
                  </div>
                </div>

                <Link to="/Solicitud" className="btn-primary" style={{ width: '100%', justifyContent: 'center', marginTop: '8px' }}>
                  Solicitar este préstamo →
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── POR QUÉ ELEGIRNOS ── */}
      <section className="section razones-section">
        <div className="container">
          <div className="section-header center">
            <span className="section-label">Nuestra diferencia</span>
            <h2 className="section-title">¿Por qué elegir <span>JM ODEPEM</span>?</h2>
          </div>
          <div className="razones-grid">
            {razones.map((r, i) => (
              <div key={i} className="razon-card">
                <div className="razon-icon">{r.icon}</div>
                <h3>{r.titulo}</h3>
                <p>{r.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── INSTAGRAM REELS ── */}
      <section className="section instagram-section">
        <div className="container">
          <div className="section-header center">
            <span className="section-label">Síguenos en Instagram</span>
            <h2 className="section-title">Nuestros últimos <span>Reels</span></h2>
            <p className="section-subtitle">
              Mantente al día con nuestras novedades, consejos financieros y promociones.
            </p>
          </div>
          <div className="instagram-widget-wrap">
            <div
              className="elfsight-app-8b2e49f5-5143-4b54-9be5-7a597cf4477d"
              data-elfsight-app-lazy
            ></div>
          </div>
          <div className="instagram-cta">
            <a
              href="https://www.instagram.com/jmodepem/"
              target="_blank"
              rel="noreferrer"
              className="btn-outline"
            >
              Ver perfil completo →
            </a>
          </div>
        </div>
      </section>

      {/* ── CTA FINAL ── */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-box">
            <div className="cta-left">
              <h2>¿Listo para alcanzar <span>tus metas</span>?</h2>
              <p>Contáctanos hoy y uno de nuestros asesores te ayudará a encontrar la mejor solución financiera para ti.</p>
            </div>
            <div className="cta-right">
              <Link to="/Solicitud" className="btn-white">
                Solicitar préstamo →
              </Link>
              <a href="tel:+18098227417" className="btn-outline-white">
                📞 809-822-7417
              </a>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Home;